import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  DashboardPublishedContainerBody,
  DashboardContainerHeader, DashboardContainer,
  DividerContainer,
  FromContainer,
  UntilContainer
} from '../MoaDashboard.styles';
import { Divider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker, TimeView } from '@mui/x-date-pickers';
import { PublishedContainerProps } from './PublishedContainer.types';
import React from 'react';
import { Dayjs } from 'dayjs';
import { debounce } from "lodash";
import EventCount from "../EventCount";

const PublishedContainer: React.FC<PublishedContainerProps> = ({
    isLoading,
    from,
    setFrom,
    until,
    setUntil,
    events,
}) => {
    const muiTheme = createTheme();

    const getShouldDisableTime = (value: Dayjs, view: TimeView) => {
        if (view === 'minutes') {
            return value.minute() % 30 !== 0 && value.minute() !== 55;
        }
        return false;
    }

    const debounceFrom = debounce(setFrom, 1000);
    const debounceUntil = debounce(setUntil, 1000);

    return (
        <DashboardContainer data-testid="publishedContainer">
            <DashboardContainerHeader>Published</DashboardContainerHeader>
                <DashboardPublishedContainerBody>
                    <FromContainer>
                        <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    // @ts-ignore
                                    skipDisabled={true}
                                    shouldDisableTime={getShouldDisableTime}
                                    value={from}
                                    onChange={(newValue) => debounceFrom(newValue)}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </FromContainer>
                    <DividerContainer>
                        <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
                            <Divider orientation="horizontal" variant={'middle'} flexItem
                                sx={{ width: '16px', borderBottomWidth: '2px', backgroundColor: '#131313' }} />
                        </ThemeProvider>
                    </DividerContainer>
                    <UntilContainer>
                        <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    // @ts-ignore
                                    skipDisabled={true}
                                    shouldDisableTime={getShouldDisableTime}
                                    value={until}
                                    onChange={(newValue) => debounceUntil(newValue)}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </UntilContainer>
                    <EventCount
                        label={'Events'}
                        count={events}
                        isLoading={isLoading}
                    />
                </DashboardPublishedContainerBody>
        </DashboardContainer>
    );
};

export default PublishedContainer;